import React, { useState, useEffect } from 'react';

const modalStyles = {
  overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '16px' },
  content: { background: 'white', borderRadius: '16px', width: '100%', maxWidth: '800px', maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' },
  headerCyan: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)' },
  closeBtn: { background: 'none', border: 'none', fontSize: '24px', color: 'rgba(255,255,255,0.8)', cursor: 'pointer', padding: '4px', lineHeight: 1 },
  body: { flex: 1, overflowY: 'auto', padding: '20px' },
  subtitle: { margin: '0 0 20px', fontSize: '14px', color: '#64748b' },
  formGroup: { marginBottom: '16px' },
  label: { display: 'block', marginBottom: '6px', fontSize: '14px', fontWeight: 500, color: '#334155' },
  input: { width: '100%', padding: '12px 14px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', background: 'white', boxSizing: 'border-box' },
  textarea: { width: '100%', padding: '12px 14px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', background: 'white', boxSizing: 'border-box', minHeight: '70px', fontFamily: 'inherit', resize: 'vertical' },
  formRow2: { display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' },
  formRow3: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px' },
  typeSourceCard: { border: '2px solid #a5f3fc', borderRadius: '12px', padding: '14px', background: '#ecfeff', marginBottom: '20px' },
  typeSourceLabel: { display: 'block', marginBottom: '10px', fontSize: '15px', fontWeight: 700, color: '#0e7490' },
  typeSourceDesc: { marginTop: '8px', fontSize: '12px', color: '#475569', fontStyle: 'italic' },
  sectionTitle: { fontSize: '15px', fontWeight: 600, color: '#0e7490', borderTop: '2px solid #a5f3fc', paddingTop: '14px', marginTop: '20px', marginBottom: '12px' },
  footer: { display: 'flex', gap: '12px', padding: '16px 20px', borderTop: '1px solid #e2e8f0', background: '#f8fafc' },
  btnSecondary: { flex: 1, padding: '12px 16px', borderRadius: '8px', fontSize: '14px', fontWeight: 600, cursor: 'pointer', background: 'white', border: '1px solid #d1d5db', color: '#374151' },
  btnCyan: { flex: 1, padding: '12px 16px', borderRadius: '8px', fontSize: '14px', fontWeight: 600, cursor: 'pointer', background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)', border: 'none', color: 'white' }
};

const TYPE_SOURCE_DESCRIPTIONS = {
  principale: '⚡ Cette source remplacera automatiquement la source basse tension sur le PDF',
  secondaire: '🔋 Source de secours affichée dans le rapport',
  remplacement: '🔄 Cette source sera affichée en parallèle de la source principale sur le synoptique',
  securite: '🛡️ Cette source sera affichée en parallèle de la source principale sur le synoptique'
};

const EMPTY_DATA = {
  type_source: 'principale',
  localisation: '',
  designation: '',
  nature_source: 'Groupe électrogène',
  installations_alimentees: '',
  marque: '',
  numero: '',
  puissance: '',
  tension: '',
  intensite: '',
  dielectrique_ucc: '',
  schema_liaison_terre: 'TT',
  protection_secondaire: ''
};

function SourceAutonomeModalMobile({ isOpen, onClose, onSave, initialData }) {
  const [data, setData] = useState({ ...EMPTY_DATA, ...(initialData || {}) });

  useEffect(() => {
    if (isOpen) {
      setData({ ...EMPTY_DATA, ...(initialData || {}) });
    }
  }, [isOpen, initialData]);

  const handleChange = (field, value) => {
    setData(prev => ({ ...prev, [field]: value }));
  };

  const isValid = !!data.localisation && !!data.designation && !!data.nature_source && !!data.puissance;

  const handleSave = () => {
    if (!isValid) return;
    onSave(data);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div style={modalStyles.overlay} onClick={onClose}>
      <div style={modalStyles.content} onClick={(e) => e.stopPropagation()}>
        <div style={modalStyles.headerCyan}>
          <h2 style={{margin: 0, fontSize: '18px', fontWeight: 700, color: 'white'}}>⚡ Source d'énergie (Interne BT / Autonome)</h2>
          <button style={modalStyles.closeBtn} onClick={onClose}>✕</button>
        </div>

        <div style={modalStyles.body}>
          {/* Type de source - bloc mis en avant */}
          <div style={modalStyles.typeSourceCard}>
            <label style={modalStyles.typeSourceLabel}>Type de Source</label>
            <select value={data.type_source} onChange={(e) => handleChange('type_source', e.target.value)} style={modalStyles.input}>
              <option value="principale">Principale (Remplace la source BT normale)</option>
              <option value="secondaire">Secondaire (Source de secours)</option>
              <option value="remplacement">Source de remplacement (Affichée en parallèle)</option>
              <option value="securite">Source de sécurité (Affichée en parallèle)</option>
            </select>
            <p style={modalStyles.typeSourceDesc}>
              {TYPE_SOURCE_DESCRIPTIONS[data.type_source] || ''}
            </p>
          </div>

          {/* Localisation et Désignation */}
          <div style={modalStyles.formRow2}>
            <div style={modalStyles.formGroup}>
              <label style={modalStyles.label}>Localisation *</label>
              <input type="text" value={data.localisation} onChange={(e) => handleChange('localisation', e.target.value)} style={modalStyles.input} placeholder="Ex: Extérieur, Local technique..." />
            </div>
            <div style={modalStyles.formGroup}>
              <label style={modalStyles.label}>Désignation *</label>
              <input type="text" value={data.designation} onChange={(e) => handleChange('designation', e.target.value)} style={modalStyles.input} placeholder="Ex: Groupe électrogène principal" />
            </div>
          </div>

          {/* Nature et installations alimentées */}
          <div style={modalStyles.formRow2}>
            <div style={modalStyles.formGroup}>
              <label style={modalStyles.label}>Nature de la source *</label>
              <input type="text" value={data.nature_source} onChange={(e) => handleChange('nature_source', e.target.value)} style={modalStyles.input} placeholder="Ex: Groupe électrogène" />
            </div>
            <div style={modalStyles.formGroup}>
              <label style={modalStyles.label}>Installations alimentées</label>
              <textarea value={data.installations_alimentees} onChange={(e) => handleChange('installations_alimentees', e.target.value)} style={modalStyles.textarea} placeholder="Liste des installations alimentées par cette source" />
            </div>
          </div>

          {/* Caractéristiques */}
          <div style={modalStyles.sectionTitle}>Caractéristiques de la source</div>

          <div style={modalStyles.formRow3}>
            <div style={modalStyles.formGroup}>
              <label style={modalStyles.label}>Marque</label>
              <input type="text" value={data.marque} onChange={(e) => handleChange('marque', e.target.value)} style={modalStyles.input} placeholder="Ex: Caterpillar, SDMO..." />
            </div>
            <div style={modalStyles.formGroup}>
              <label style={modalStyles.label}>Numéro</label>
              <input type="text" value={data.numero} onChange={(e) => handleChange('numero', e.target.value)} style={modalStyles.input} placeholder="N° de série" />
            </div>
            <div style={modalStyles.formGroup}>
              <label style={modalStyles.label}>Puissance (kVA) *</label>
              <input type="number" value={data.puissance} onChange={(e) => handleChange('puissance', e.target.value)} style={modalStyles.input} placeholder="Ex: 150" />
            </div>
          </div>

          <div style={modalStyles.formRow3}>
            <div style={modalStyles.formGroup}>
              <label style={modalStyles.label}>Tension (V)</label>
              <input type="number" value={data.tension} onChange={(e) => handleChange('tension', e.target.value)} style={modalStyles.input} placeholder="Ex: 400" />
            </div>
            <div style={modalStyles.formGroup}>
              <label style={modalStyles.label}>Intensité (A)</label>
              <input type="number" value={data.intensite} onChange={(e) => handleChange('intensite', e.target.value)} style={modalStyles.input} placeholder="Ex: 217" />
            </div>
            <div style={modalStyles.formGroup}>
              <label style={modalStyles.label}>Tension de court-circuit Ucc (%)</label>
              <input type="number" step="0.1" value={data.dielectrique_ucc} onChange={(e) => handleChange('dielectrique_ucc', e.target.value)} style={modalStyles.input} placeholder="Ex: 6" />
            </div>
          </div>

          <div style={modalStyles.formRow2}>
            <div style={modalStyles.formGroup}>
              <label style={modalStyles.label}>Schéma des liaisons à la terre</label>
              <select value={data.schema_liaison_terre} onChange={(e) => handleChange('schema_liaison_terre', e.target.value)} style={modalStyles.input}>
                <option value="TT">TT</option>
                <option value="TN">TN</option>
                <option value="TN-C">TN-C</option>
                <option value="TN-S">TN-S</option>
                <option value="IT">IT</option>
              </select>
            </div>
            <div style={modalStyles.formGroup}>
              <label style={modalStyles.label}>Protection secondaire</label>
              <textarea value={data.protection_secondaire} onChange={(e) => handleChange('protection_secondaire', e.target.value)} style={modalStyles.textarea} placeholder="Description des protections secondaires" />
            </div>
          </div>
        </div>

        <div style={modalStyles.footer}>
          <button style={modalStyles.btnSecondary} onClick={onClose}>Annuler</button>
          <button style={{...modalStyles.btnCyan, opacity: isValid ? 1 : 0.5}} onClick={handleSave} disabled={!isValid}>⚡ Enregistrer la source autonome</button>
        </div>
      </div>
    </div>
  );
}

export default SourceAutonomeModalMobile;
